import { render } from "./addgroup.vue?vue&type=template&id=28b0c107&scoped=true"
import script from "./addgroup.vue?vue&type=script&lang=js"
export * from "./addgroup.vue?vue&type=script&lang=js"

import "./addgroup.vue?vue&type=style&index=0&id=28b0c107&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b0c107"]])

export default __exports__